import { useNavigate } from 'react-router-dom';
import { ActionIcon, Indicator, Tooltip } from '@mantine/core';
import { IconBell } from '@tabler/icons-react';
import { useUnreadMessages } from './useUnreadMessages';

/** Колокол с бейджем непрочитанных сообщений. Переход на /messages. */
export function MessagesBell({ enabled }: { enabled: boolean }) {
  const navigate = useNavigate();
  const { unread } = useUnreadMessages(enabled);

  if (!enabled) return null;

  return (
    <Tooltip label="Сообщения" position="right">
      <Indicator
        inline
        disabled={unread === 0}
        label={unread > 99 ? '99+' : unread}
        size={16}
        color="red"
        offset={4}
      >
        <ActionIcon variant="subtle" size="lg" onClick={() => navigate('/messages')} aria-label="Сообщения">
          <IconBell size={20} />
        </ActionIcon>
      </Indicator>
    </Tooltip>
  );
}
